import axios from 'axios';

const jwtAxios = axios.create({
  //local
  // baseURL: 'http://localhost:8080/api/',
  //test api
  // baseURL: 'https://apitest.gudmed.in/api/',
  //uat link
 baseURL : 'https://ec2api.gudmed.in/api/',
  // headers: {
  //   'Content-Type': 'application/json',
  // },
  //live Api url link
  // baseURL: 'https://testapi.gudmed.in/api/',
  headers: {
    'Content-Type': 'application/json',
  },
  validateStatus: function (status) {
    return status >= 200 && status < 400;
  },
});
jwtAxios.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response && err.response.data.msg === 'Token is not valid') {
      console.log('Need to logout user');
      // store.dispatch({type: LOGOUT});
    }
    return Promise.reject(err);
  },
);
export const setAuthToken = (token) => {
  if (token) {
    jwtAxios.defaults.headers.common['x-auth-token'] = token;
    localStorage.setItem('token', token);
  } else {
    delete jwtAxios.defaults.headers.common['x-auth-token'];
    localStorage.removeItem('token');
  }
};

export default jwtAxios;
